import { getAxiosInstance } from '@utils/request';
import { Coordinate } from 'ol/coordinate';

export interface SearchGeocode {
  id: number;
  address: string;
  coordinates: Coordinate;
  features: {
    geometry: {
      type: string;
      coordinates: Coordinate;
    };
    properties: {
      address: string;
      accuracy: number;
    };
  };
}

export class APISearch {
  readonly url = 'api/';
  async list(type: string, address: string) {
    const response = await getAxiosInstance().get<SearchGeocode>(
      `${this.url}${
        type === 'yandex-search'
          ? 'yandex-search/?_address='
          : 'geocode/?_address='
      }${address}`,
    );

    return response;
  }
}
